import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as appConstants from '../../../overrides/appconstants'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import Select from 'react-select';
import MedicalApplicationForm from './MedicalApplicationForm'
import * as actions from '../actions/micustomeractions'
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
export default function BasicMemberInfo() {

    const { register, handleSubmit, reset, setValue, formState: { errors }, clearErrors } = useForm();
    const dispatch = useDispatch();
    const state = useSelector(state => state.miCustomerSharedReducer);

    const filteredMemberList = state.memberBasicInfo?.filteredMemberList;
    const memberList = state.memberBasicInfo?.memberList;
    const basicInfoNewEnq = state.basicInfoNewEnq;
    const isFromSearch = state.isFromSearch;

    useEffect(() => {
        filteredMemberList.forEach(m => {
            let valuesToMap = [
                { ["memberFullName" + m.srlNo]: m.memberFullName },
                { ["nationality" + m.srlNo]: m.nationality },
                { ["memberDateOfBirth" + m.srlNo]: m.memberDateOfBirth },
                { ["relation" + m.srlNo]: m.relation },
                { ["memberGender" + m.srlNo]: m.memberGender },
                { ["memberMaritalStatus" + m.srlNo]: m.memberMaritalStatus }
            ];
            valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
        });
    }, [filteredMemberList]);

    useEffect(() => {

        if (basicInfoNewEnq?.encryptedEnquiryRefId1 && basicInfoNewEnq?.encryptedEnquiryRefId2) {
            dispatch(actions.getQuoteMembers())
        }

    }, [basicInfoNewEnq]);
    // console.log('filteredMemberList', filteredMemberList);
    // console.log('memberList', memberList);
    // console.log('memberBasicInfo', state.memberBasicInfo);




    var masters = state.masters;
    // console.log('genderMasters', masters?.genderMasters);

    let activeStep = state.activeStep;
    const handleBasicMemberInfoQuoteChange = (e) => { }

    const handleBack = () => {
        dispatch(actions.handleNextStep(0))
    }
    const skiptomaf = () => { //testing
        dispatch(actions.handleNextStep(3))
    }



    const onAddMember = () => {
        // debugger;
        reset();
        dispatch(actions.addMember());
        // resetField("firstName2");
    }
    const onDeleteMember = async (memberList) => {
        reset();


        dispatch(actions.deleteMember(memberList));
    }
    const searchMemberTable = (e) => {
        let { name, value } = e.target;
        // dispatch(actions.updateIndicativeMemberTableSearchParams({ name, value }));
    }

    const updateBasicMemberInfoList = async (e) => {

        let id = e.target.id.match(/\d+/g)
        //id = id[0] - 1;
        var { name, value } = e.target;
        var inputName = name.match(/[a-zA-Z]+/g);
        name = inputName[0];
        await dispatch(actions.updateBasicMemberInfoList({ id, name, value }));

        var checkIfPrincipal = memberList?.find(p => p?.relation == appConstants.RELATION_PRINCIPAL_ID)


        if (name == "relation" && checkIfPrincipal && value == appConstants.RELATION_SPOUSE) {
            await dispatch(actions.updateBasicMemberInfoList({ id, name: "memberMaritalStatus", value: appConstants.MARITAL_STATUS_MARRIED_ID }));
            await dispatch(actions.updateBasicMemberInfoList({ id: checkIfPrincipal?.srlNo, name: "memberMaritalStatus", value: appConstants.MARITAL_STATUS_MARRIED_ID }));
            clearErrors(`memberMaritalStatus${id}`);
            clearErrors(`memberMaritalStatus${checkIfPrincipal?.id}`);
            if (checkIfPrincipal?.memberGender != null && checkIfPrincipal?.memberGender != "") {
                await dispatch(actions.updateBasicMemberInfoList({ id, name: "memberGender", value: checkIfPrincipal?.memberGender == appConstants.GENDER_MALE ? appConstants.GENDER_FEMALE : appConstants.GENDER_MALE }));
                clearErrors(`memberGender${id}`);
            }
        }



        {
            let dynamicName = e.target.name
            let valuesToMap = [
                { [dynamicName]: value },
            ];
            await valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
        }
    }

    const handleAllMemberCheckboxChange = (e) => {
        let checked = e.target.checked;
        // dispatch(actions.updateAllIndicativeMemberCheckboxParams(checked));

    }
    const handleMemberCheckboxChange = (e) => {
        let { id, checked } = e.target;
        // dispatch(actions.updateIndicativeMemberCheckboxParams({ checked, id }));
        //dispatch(actions.isPrincipal({ checked, id }));
    }

    const getProductPlanByVisaEmirateIdForIndicativeQuote = async () => {
        await dispatch(actions.getProductPlanByVisaEmirateIdForIndicativeQuote(basicInfoNewEnq?.visaEmirate));
    }
    const onSubmit = async (data) => {
        const year = appUtility.getCurrentYear()
        var ageError = memberList?.find(mem => year - new Date(mem.memberDateOfBirth).getFullYear() > appConstants.MAX_ALLOWED_AGE);



        if (ageError) {
            let dialogeData = {
                message: "Member above 70 years are not eligible for this plan",
                showConfirmPopup: true,
                isConfirm: false,
                isInfo: true,

            }
            await dispatch(actions.toggleConfirmPopup(dialogeData));
            return;
        }

        if (basicInfoNewEnq?.visaType == appConstants.VISA_TYPE_DOMESTIC || basicInfoNewEnq?.visaType == appConstants.VISA_TYPE_INVESTER) {
            var relationError = memberList?.find(w => w.relation == appConstants.RELATION_CHILDREN_ID || w.relation == appConstants.RELATION_SPOUSE);

            if (relationError) {
                let dialogeData = {
                    message: "Member relation can't be child or spuose for  selected visa type",
                    showConfirmPopup: true,
                    isConfirm: false,
                    isInfo: true,

                }
                await dispatch(actions.toggleConfirmPopup(dialogeData));
                return;
            }
        }


        if (!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued) {
            await dispatch(actions.saveMICustomerMemberBasicInfo(null))

                let dialogeData = {
                    message: "Member Details Saved Successfully!!",
                    showConfirmPopup: true,
                    isConfirm: false,
                    isInfo: true,

                }

                await dispatch(actions.toggleConfirmPopup(dialogeData));
            }
        // if (basicInfoNewEnq?.visaEmirate != null && basicInfoNewEnq?.visaEmirate != "") {
        //     getProductPlanByVisaEmirateIdForIndicativeQuote();
        // }
        dispatch(actions.handleNextStep(2))
        // if (data?.isSponsorMember) {
        //     dispatch(actions.addSponserToQuote())
        // }
        await dispatch(actions.toggleBasePremModel(false))
        await dispatch(actions.togglePlanTOBModel(false))
    };
    const onErrors = (error) => {

        console.log('Form Error:', error);
        // dispatch(actions.handleNextStep(2))
        // dispatch(actions.saveMICustomerEnquiry())
        //   setActiveStep((prevStep) => prevStep + 1);
    };
    function renderMemberDetails() {
        let relMaster = masters?.relationMasters;
        if (basicInfoNewEnq?.visaType == appConstants.VISA_TYPE_SELF_DEP) {
            relMaster = relMaster.filter(w => w.id != appConstants.RELATION_PRINCIPAL_ID)
        }

        return (
            <>
                <div className="row g-2">
                    <div className="mb-2 col-md-1">
                    </div>
                </div >

                <div className="row g-2">
                    <div className="mb-2 col-md-12">
                        <div className="btn-group float-end" id="tooltip-container2">

                            {!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued && <button type="button" className="btn btn-primary" data-bs-container="#tooltip-container2"
                                data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New Member" onClick={() => onAddMember()} >
                                <i className="dripicons-plus" style={{ color: 'white', fontSize: '20px', cursor: 'pointer' }} ></i>
                                New Member
                            </button>}
                            {/* <button type="button" className="btn btn-success" data-bs-container="#tooltip-container2"
                                data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New Member" disabled={insuredInfo.singleMemberPolicyYN} onClick={() => onAddMember()} >
                            
                            </button> */}
                            {/* disabled={!indicativeQuote.hasCheckedBoxInMemberList} */}
                            {/* <button type="button" className="btn btn-danger" data-bs-container="#tooltip-container2"
                                data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete Member" onClick={() => onDeleteMember()} >
                                <i className="dripicons-trash"></i>
                            </button> */}
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit, onErrors)}>

                    <div className="table-responsive">
                        <table className="table table-hover table-custom">
                            <thead className="table-header">
                                <tr>
                                    {/* <th>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                id="CheckAll"
                                                className="form-check-input"
                                                onChange={value => handleAllMemberCheckboxChange(value)}
                                            />
                                        </div>
                                    </th> */}
                                    <th>No.</th>
                                    <th><span className='text-danger'>*</span> Full Name</th>
                                    <th><span className='text-danger'>*</span> Nationality</th>
                                    <th><span className='text-danger'>*</span> Date of Birth</th>
                                    <th><span className='text-danger'>*</span> Relation</th>
                                    <th><span className='text-danger'>*</span> Gender</th>
                                    <th><span className='text-danger'>*</span> Marital Status</th>
                                    {!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued && <th>Options</th>}
                                </tr>
                            </thead>
                            {filteredMemberList.length != 0 ? (
                                <tbody>
                                    {filteredMemberList.map((memberList, index) => (
                                        <tr key={memberList.srlNo} className="table-row">
                                            {/* <td>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        id={memberList.srlNo}
                                                        className="form-check-input"
                                                        checked={memberList.isChecked}
                                                        onChange={value => handleMemberCheckboxChange(value)}
                                                        value={memberList.srlNo}
                                                    />
                                                </div>
                                            </td> */}
                                            <td className='align-middle'>{memberList.srlNo}</td>
                                            <td>
                                                <input
                                                    className={`form-control ${errors[`memberFullName${memberList.srlNo}`] ? "is-invalid" : ""
                                                        }`}
                                                    type="text"
                                                    placeholder='Enter Full Name'
                                                    id={`memberFullName${memberList.srlNo}`}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`memberFullName${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued,
                                                        pattern: {
                                                            value: /^[A-Za-z ]+$/,
                                                            message: "Full Name must contain only letters and spaces"
                                                        },
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                    value={memberList.memberFullName}
                                                />
                                                {errors[`memberFullName${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'> {errors[`memberFullName${memberList.srlNo}`].message}</span>}
                                            </td>
                                            {/* <td>
                                            <input
                                                className={`form-control ${errors[`memberLastName${memberList.srlNo}`] ? "is-invalid" : ""
                                                    }`}
                                                type="text"
                                                id={`memberLastName${memberList.srlNo}`}
                                                {...register(`memberLastName${memberList.srlNo}`, {
                                                    required: insuredInfo.singleMemberPolicyYN,
                                                    onChange: e => updateBasicMemberInfoList(e),
                                                })}
                                                value={memberList.memberLastName}
                                            />
                                        </td> */}


                                            <td>


                                                <select
                                                    className={`form-select ${errors[`nationality${memberList.srlNo}`] ? "is-invalid" : ""
                                                        }`}
                                                    data-toggle="select2"
                                                    id={"nationality" + memberList.srlNo}
                                                    name={"nationality" + memberList.srlNo}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`nationality${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued,
                                                        onChange: (e) => updateBasicMemberInfoList(e),

                                                    })} >
                                                    <option value=''>Select </option>
                                                    {masters?.nationalityMaster?.map((NationalityMasters, index) => (

                                                        <option value={NationalityMasters.domainValue} key={index}>
                                                            {NationalityMasters.domainValueName}
                                                        </option>
                                                    ))
                                                    }
                                                </select>
                                                {errors[`nationality${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                            </td>
                                            <td>
                                                <input
                                                    className={`form-control ${errors[`memberDateOfBirth${memberList.srlNo}`] ? "is-invalid" : ""
                                                        }`}
                                                    type="date"
                                                    // max={"9999-12-31"}
                                                    max={appUtility.formatDate(appConstants.TODAY)}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    id={`memberDateOfBirth${memberList.srlNo}`}
                                                    {...register(`memberDateOfBirth${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued,
                                                        // required: "Field is Required",
                                                        max: memberList.relation == appConstants.RELATION_PRINCIPAL_ID
                                                            ? {
                                                                value: appUtility.subtractYears(appConstants.TODAY, 18),
                                                                message: "Principal cannot be less than 18 years of age.",
                                                            }
                                                            : {
                                                                value: appUtility.formatDate(appConstants.TODAY),
                                                                message: "Enter a valid Date of Birth",
                                                            },
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                    value={memberList.memberDateOfBirth}
                                                />
                                                {errors[`memberDateOfBirth${memberList.srlNo}`]?.message && (
                                                    <span className="text-danger fst-italic fs-6">
                                                        {errors[`memberDateOfBirth${memberList.srlNo}`]?.message}
                                                    </span>
                                                )}
                                                {/* {errors[`memberDateOfBirth${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>} */}
                                            </td>
                                            <td>
                                                <select
                                                    className={`form-select ${errors[`relation${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                    value={memberList.relation}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`relation${memberList.srlNo}`, {
                                                        // required: true,
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued,
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                    id={"relation" + memberList.srlNo}
                                                >
                                                    <option value="">--Relation--</option>
                                                    {relMaster?.map(relation => (
                                                        <option key={relation.id} value={relation.id}>
                                                            {relation.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors[`relation${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                            </td>
                                            <td>
                                                <select
                                                    className={`form-select ${errors[`memberGender${memberList.srlNo}`] ? "is-invalid" : ""}`}
                                                    value={memberList.memberGender}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`memberGender${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued,
                                                        // required: true,
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                    id={"memberGender" + memberList.srlNo}
                                                >
                                                    <option value="">--Gender--</option>
                                                    {masters?.genderMasters?.map(gender => (
                                                        <option key={gender.id} value={gender.id}>
                                                            {gender.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors[`memberGender${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                            </td>
                                            <td>
                                                <select
                                                    className={`form-select ${errors[`memberMaritalStatus${memberList.srlNo}`] ? "is-invalid" : ""
                                                        }`}
                                                    id={"memberMaritalStatus" + memberList.srlNo}
                                                    value={memberList.memberMaritalStatus}
                                                    disabled={basicInfoNewEnq?.isRefertoUW || basicInfoNewEnq?.isPolicyIssued}
                                                    {...register(`memberMaritalStatus${memberList.srlNo}`, {
                                                        required: !basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued,
                                                        onChange: e => updateBasicMemberInfoList(e),
                                                    })}
                                                >
                                                    <option value="">--Marital Status--</option>
                                                    {masters?.maritalStatusMasters?.map(maritalStatus => (
                                                        <option key={maritalStatus.id} value={maritalStatus.id}>
                                                            {maritalStatus.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors[`memberMaritalStatus${memberList.srlNo}`] && <span className='text-danger fst-italic fs-6'>Field is Required</span>}
                                            </td>
                                            <td className='align-middle'>
                                                {!basicInfoNewEnq?.isRefertoUW && !basicInfoNewEnq?.isPolicyIssued && <div className='d-flex justify-content-between'>
                                                    {/* <i class="dripicons-preview" style={{ color: '#1976d2', fontSize: '16px', cursor: 'pointer' }} title="View/Edit MAF">
                                                    </i> */}

                                                    {/* <button type="button" class="btn btn-info btn-sm mx-2" data-bs-container="#tooltip-container2"
                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="View/Edit MAF">
                                            </button> */}
                                                    {/* <button type="button" class="btn btn-danger btn-sm" data-bs-container="#tooltip-container2"
                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete">     </button> */}
                                                    <i class="dripicons-trash" style={{ color: 'red', cursor: 'pointer' }} title="Delete" onClick={() => onDeleteMember(memberList)}>
                                                    </i>
                                                </div>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            <div className="alert alert-warning">No Members Found...</div>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                    <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            className='mx-2'
                            variant="outlined"
                            type='button'
                            color="secondary"
                            onClick={handleBack}
                            startIcon={<ArrowBackIcon />}
                            disabled={activeStep === 0}
                        >
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            // onClick={handleNext}
                            endIcon={
                                <ArrowForwardIcon />
                            }
                        >
                            Next
                        </Button>
                        {/* {state?.productSelection?.plansList.length > 0 &&
                            <Button
                                className='mx-2'
                                variant="outlined"
                                type='button'
                                color="secondary"
                                onClick={skiptomaf}
                                startIcon={<ArrowBackIcon />}
                                disabled={activeStep === 0}
                            >
                                ---skiptoMAFforTesting---
                            </Button>
                        } */}


                    </Box>
                </form>

            </>
        )
    }

    return (
        <>
            <ul className="nav nav-tabs nav-bordered mb-1">
            </ul>
            <div className="row g-2">
                <div className="mb-1 col-md-12">
                </div>
            </div>
            <div className="collapse show" id="CollapseBasicMemberInfoQuote">
                {renderMemberDetails()}
            </div >
        </>

    )


}